import { LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemMedia.css'

/**
 * Item Media holds the leading visual of an [Item](/components/item/), such as
 * an icon, an avatar or an image.
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for the media content (an icon, avatar or image).
 */
@customElement('nord-item-media')
export default class ItemMedia extends LitElement {
  /**
   * The visual style of the media container.
   *
   * - `default` simply centers its content.
   * - `icon` renders a small bordered, muted square that centers an icon.
   * - `image` renders a rounded square that clips an image to a cover fit.
   */
  @property({ reflect: true }) variant: 'default' | 'icon' | 'image' = 'default'

  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-media': ItemMedia
  }
}
